<template>
  <div class="wk_finiture_view wrapper">
    <div class="d-flex flex-column w-100 mx-2">
      <div class="d-flex align-center w-33 ma-3">
         <span class="wk_lista-finiture_label">finishes filters</span>
      </div>

      <div class="mb-8" style="color: grey;">
        <p style="text-align: center;">Changes to the display names of finishes will be enabled soon!</p>
        <p style="text-align: center;">Changes made on this screen, including the order, will be reflected in the search field on the Producibility and Stocks views.</p>
      </div>

      <div class="text-center" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </div>

      <DataTable
        v-else
        :value="finiture"
        :reorderable-columns="true"
        @rowReorder="onRowReorder"
        v-model:editingRows="editingRows"
        editMode="row"
        @row-edit-save="onRowEditSave"
        class="p-datatable-sm"
        lazy
        resizableColumns
        columnResizeMode="expand"
      >
        <Column
          v-if="isAdmin"
          rowReorder
          field="index"
          headerStyle="width: 6rem"
          :reorderableColumn="false"
        />
        <Column field="name" header="Name"/>
        <Column field="new_name" header="Display name">
          <template #editor="{ data, field }">
            <InputText v-model="data[field]" />
          </template>
        </Column>
        <Column field="code" header="Code"></Column>
        <Column field="visibile" header="Filter visibility">
          <template #body="{ data, field }">
            <v-switch
              v-model="data[field]"
              color="green"
              hide-details
              outset
              :disabled="!isAdmin || true"
            ></v-switch>
          </template>
        </Column>
        <Column
            v-if="false"
          field="action_edit"
          :rowEditor="isAdmin"
          style="width: 50px; min-width: 8rem"
          bodyStyle="text-align:right"
        ></Column>
      </DataTable>

      <v-snackbar v-model="snackbar" :timeout="defaultTimeout()">
        {{ text }}

        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar = false">
            Chiudi
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<style scoped>
.wk_lista-finiture_label {
  font-size: 20px;
  width: 100%;
  margin: 50px 0;
}
</style>

<script>
import axios from "axios";
import {
  API_URL,
  defaultTimeout,
  notifyError,
  notifyLoading, notifySaving,
} from "@/utils/const";
import authHeader from "@/services/data.service";
import store from "@/store";

export default {
  data() {
    return {
      loading: false,
      finiture: null,
      editingRows: [],
      text: "Loaded correctly",
      snackbar: false,
      new_name_tmp: "",
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    }
  },
  async mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    }

    if (store.getters["auth/loggedIn"]) {
      await store.dispatch("auth/role");
    }

    this.loading = true;

    await this.getFiniture();

    this.loading = false;
  },
  methods: {
    defaultTimeout() {
      return defaultTimeout;
    },
    async getFiniture() {
      await axios
        .get(API_URL + "finiture/all", { headers: authHeader() })
        .then((response) => {
          this.finiture = response.data;
          this.text = notifyLoading;
          this.snackbar = true;
        })
        .catch((error) => {
          console.error("Error while getting all colori", error);
          this.text = notifyError;
          this.snackbar = true;
        });
    },
    async updateFinishName(
        _id,
        newName
    ) {
      const body = {
        _id: _id,
        new_name: newName,
      };

      return await axios
          .put(API_URL + 'finiture/update-name', body, {headers: authHeader()})
          .then((response) => {
            if (response.data) {
              return response.data;
            }
            return null;
          })
          .catch(() => {
            this.text = notifyError;
            this.snackbar = true;
            return null;
          });
    },
    async updateIndex(id, index) {
      const body = { _id: id, index: index };
      await axios
          .put(API_URL + "finiture/reorder", body, { headers: authHeader() })
          .then(() => {
            this.text = notifySaving;
            this.snackbar = true;
          })
          .catch(() => {
            this.text = notifyError;
            this.snackbar = true;
          });
    },
    onRowReorder(event) {
      this.finiture = event.value;
      for (let i = 0; i < this.finiture.length; i++) {
        if (i !== this.finiture[i].index) {
          this.updateIndex(this.finiture[i]._id, i);
          this.finiture[i].index = i;
          console.log(
              `${this.finiture[i].name} has index: ${this.finiture[i].index}`
          );
        }
      }
    },
    async onRowEditInit(event) {
      let { index } = event;
      this.new_name_tmp = this.finiture[index].new_name;
    },
    async onRowEditSave() {
      /**
      if (data.new_name === "") {
        let result = await this.updateFinishName(data._id, data.name);

        if (result) {
          this.finiture[index].new_name = data.new_name;
          this.text = notifySaving;
          this.snackbar = true;
        }

        this.finiture[index].new_name = data.name;
      } else {
        let result = await this.updateFinishName(data._id, data.new_name);

        if (result) {
          this.finiture[index].new_name =  data.new_name;
          this.text = notifySaving;
          this.snackbar = true;
        }
      }
      this.finiture[index] = data;
          */
    },
  },
};
</script>
